var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCare3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 178.17 180.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #292e4e;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #351d26;\r\n      }\r\n\r\n      .cls-3 {\r\n        mix-blend-mode: multiply;\r\n        opacity: .25;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke: #52587c;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-4, .cls-5, .cls-9 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: #c3dbed;\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: #545a95;\r\n      }\r\n\r\n      .cls-12 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: #52587c;\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: #dbc7c6;\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: #393f6d;\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: #c6d5e5;\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: #f9f9f9;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke: #393f6d;\r\n        stroke-width: 2.5px;\r\n      }\r\n\r\n      .cls-18 {\r\n        opacity: .45;\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: #8fc8cc;\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: #754e48;\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: #a8c9e2;\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: #548393;\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: #ede2e1;\r\n      }\r\n\r\n      .cls-6 {\r\n        stroke: #373d68;\r\n      }\r\n\r\n      .cls-6, .cls-7, .cls-8 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-6, .cls-8, .cls-9 {\r\n        stroke-width: .5px;\r\n      }\r\n\r\n      .cls-7 {\r\n        stroke: #dbc7c6;\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: #d7e8f4;\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: #f2beb0;\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: #d36262;\r\n      }\r\n\r\n      .cls-8 {\r\n        stroke: #dd816c;\r\n      }\r\n\r\n      .cls-27 {\r\n        fill: #2d3254;\r\n      }\r\n\r\n      .cls-9 {\r\n        stroke: #a54141;\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: #5e3643;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 137.82,
    y1: 85.23,
    x2: 137.82,
    y2: 150.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 142.85,
    y1: 63.19,
    x2: 142.85,
    y2: 149.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 164.47,
    y1: 85.23,
    x2: 164.47,
    y2: 150.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 169.5,
    y1: 63.19,
    x2: 169.5,
    y2: 149.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 136.19,
    y: 84.02,
    width: 28.28,
    height: 2.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 142.16,
    y: 58.22,
    width: 28.28,
    height: 11.37
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "170.44 69.59 171.13 69.22 171.13 57.85 170.44 58.22 170.44 69.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "171.13 57.85 142.85 57.85 142.16 58.22 170.44 58.22 171.13 57.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "164.47 86.44 170.44 84.02 170.44 81.59 164.47 84.02 164.47 86.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "170.44 81.59 142.16 81.59 136.19 84.02 164.47 84.02 170.44 81.59"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M138.27,80.69c.27-.17.57-.3.86-.44.82-.39,1.6-.87,2.32-1.41.82-.61.95-2,.5-2.89-.46-.91-1.62-1.39-1.9-2.38-.08-.28-.08-.57-.09-.85,0-.74.07-1.45.08-2.18,0-.79.03-2.03.44-2.73.08-.13.23-.23.39-.2.06.02.12.05.18.09.31.22.63.43.94.65.14.09.28.19.44.23.14.03.29.02.43,0,.32-.03.64-.05.96-.08.11,0,.23-.02.33-.07.14-.07.22-.21.3-.34.36-.58.78-1.13,1.24-1.64.1-.11.28-.1.36.02.29.41.56.85.78,1.3.23.46.3.85.43,1.33.24.88.64,1.86,1.49,2.3.89.46,1.99.18,2.89-.27,2.44-1.21,5.1-2.75,7.93-2.94,3.49-.25,6.18,2.21,7.94,5.01,1.11,1.77,1.79,3.92,1.39,5.98,0,1.44-1.49,2.93-2.61,3.63-.67.42-1.3.64-2.08.72-.94.1-1.82.46-2.72.76-.49.17-.99.34-1.4.66-.3.24-.54.55-.86.76-.32.21-.77.31-1.07.07-.07-.7.31-1.37.8-1.87.31-.31,1.6-1.03,1.57-1.49-.04-.5-1.3-.85-1.69-.91-.5-.08-1.01-.05-1.51-.02-3.18.22-6.34.6-9.49,1.13-.69.12-1.41.25-1.98.65-.66.47-1.06,1.25-1.75,1.68-.26.16-.57.27-.86.19-.52-.14-.73-.81-.57-1.32s.59-.89.99-1.25c.67-.59,1.35-1.18,2.02-1.77-1.91.28-3.78.77-5.58,1.46-.56.21-1.17.5-1.39,1.05-.11.26-.11.57-.27.81-.26.41-.89.46-1.28.18s-.55-.81-.5-1.29.3-.92.58-1.31c.22-.31.47-.61.78-.84.07-.06.15-.11.23-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M166.58,80.26c2.12-.11,3.76,1.37,3.73,3.39-.03,2.12-.91,4.13.57,6.06,2.38,3.11,6.98,1,7.29-2.54.06-.69-.15-1.53-.82-1.73-.9-.27-1.64,2.4-2.06,2.92-.63.77-1.83,1.07-2.64.39-.92-.78-.92-2.32-.8-3.41.44-3.74-1.4-6.93-4.97-6.24"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.55,72.21s0,.09,0,.14c0,.01,0,.02,0,.03,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,0v.09s.02.05.03.07c.02.09.05.18.08.27.02.05.04.1.06.15.04.07.08.14.16.18.05.03.11.04.16.04.04,0,.09,0,.13-.03.04-.01.08-.04.1-.07.04-.04.07-.09.08-.14.02-.06.01-.08,0-.13,0-.02,0-.03,0-.05,0,0,0-.01,0-.02,0-.01,0-.02,0-.03s0-.02,0-.03c0-.02,0-.03-.02-.05,0-.02-.01-.03-.02-.05,0,0,0-.01,0-.02l.03.08c-.03-.06-.05-.12-.07-.19-.01-.03-.02-.06-.03-.09,0-.02,0-.03-.01-.05-.01-.04-.03-.08-.05-.12l.03.08c-.02-.06-.05-.11-.07-.17,0-.04-.03-.07-.05-.1-.02-.03-.05-.06-.08-.08l-.07-.03s-.08-.01-.12,0c-.03,0-.05,0-.07.02-.04.01-.07.03-.1.06l-.05.06s-.04.1-.04.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.08,71.8s0,.09,0,.14c0,.01,0,.02,0,.03,0,0,0,.01,0,.02,0,0,0,0,0,0,0,0,0,0,0,0v.09s.02.05.03.07c.02.09.05.18.08.27.02.05.04.1.06.15.04.07.08.14.16.18.05.03.11.04.16.04.04,0,.09,0,.13-.03.04-.01.08-.04.1-.07.04-.04.07-.09.08-.14.02-.06.01-.08,0-.13,0-.02,0-.03,0-.05,0,0,0-.01,0-.02,0-.01,0-.02,0-.03s0-.02,0-.03c0-.02,0-.03-.02-.05,0-.02-.01-.03-.02-.05,0,0,0-.01,0-.02l.03.08c-.03-.06-.05-.12-.07-.19-.01-.03-.02-.06-.03-.09,0-.02,0-.03-.01-.05-.01-.04-.03-.08-.05-.12l.03.08c-.02-.06-.05-.11-.07-.17,0-.04-.03-.07-.05-.1-.02-.03-.05-.06-.08-.08l-.07-.03s-.08-.01-.12,0c-.03,0-.05,0-.07.02-.04.01-.07.03-.1.06l-.05.06s-.04.1-.04.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.2,73.94c-.06-.36-.77-.2-.96-.07-.02.01-.03.02-.04.05-.04.08,0,.19.05.23.12.11.24.2.37.28.11.06.27.08.38.01.09-.05.19-.2.21-.37,0-.04,0-.09,0-.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M48.59,103.21h-4.57c-.09,0-.17-.07-.2-.18l-7.76-17.89c-.05-.18.05-.37.2-.37h4.57c.09,0,.17.07.2.18l7.76,17.89c.05.18-.05.37-.2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M39.44,103.21h-4.57c-.09,0-.17-.07-.2-.17l-4.87-16.68c-.05-.17.05-.34.2-.34h4.57c.09,0,.17.07.2.17l4.87,16.68c.05.17-.05.34-.2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M31.65,103.21h-5.43c-.05,0-.1-.07-.12-.18l-3.03-17.45c-.03-.17.03-.36.12-.36h5.43c.05,0,.1.07.12.18l3.03,17.45c.03.17-.03.36-.12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M65.14,103.21h-4.57c-.09,0-.17-.07-.2-.17l-3.63-16.68c-.05-.17.05-.34.2-.34h4.57c.09,0,.17.07.2.17l3.63,16.68c.05.17-.05.34-.2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M59.03,103.21h-8.71c-.09,0-.17-.08-.2-.2l-3.63-19.25c-.05-.19.05-.39.2-.39h8.71c.09,0,.17.08.2.2l3.63,19.25c.05.19-.05.39-.2.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 68.68,
    y: 96.57,
    width: 16.4,
    height: 6.64,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(153.77 199.78) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 68.68,
    y: 85.74,
    width: 16.4,
    height: 6.64,
    rx: 0.46,
    ry: 0.46,
    transform: "translate(153.77 178.11) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 67.55,
    y: 93.38,
    width: 15.72,
    height: 2.75,
    rx: 0.29,
    ry: 0.29,
    transform: "translate(150.83 189.51) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M40.26,69.29h-4.43c-.08,0-.16-.06-.19-.15l-3.51-15.07c-.05-.15.05-.31.19-.31h4.43c.08,0,.16.06.19.15l3.51,15.07c.05.15-.05.31-.19.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M34.35,69.29h-8.44c-.08,0-.16-.07-.19-.18l-3.51-17.39c-.05-.17.05-.36.19-.36h8.44c.08,0,.16.07.19.18l3.51,17.39c.05.17-.05.36-.19.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M47.46,69.29h-4.43c-.08,0-.16-.06-.19-.15l-4.71-15.07c-.05-.15.05-.31.19-.31h4.43c.08,0,.16.06.19.15l4.71,15.07c.05.15-.05.31-.19.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M60.91,69.29h-4.43c-.08,0-.16-.06-.19-.15l-4.71-15.07c-.05-.15.05-.31.19-.31h4.43c.08,0,.16.06.19.15l4.71,15.07c.05.15-.05.31-.19.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M71.05,69.29h-4.43c-.08,0-.16-.07-.19-.16l-7.52-16.16c-.05-.16.05-.33.19-.33h4.43c.08,0,.16.07.19.16l7.52,16.16c.05.16-.05.33-.19.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M53.36,69.29h-5.26c-.05,0-.1-.06-.12-.16l-2.94-15.77c-.03-.16.03-.32.12-.32h5.26c.05,0,.1.06.12.16l2.94,15.77c.03.16-.03.32-.12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M87.07,69.29h-4.43c-.08,0-.16-.06-.19-.15l-3.51-15.07c-.05-.15.05-.31.19-.31h4.43c.08,0,.16.06.19.15l3.51,15.07c.05.15-.05.31-.19.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M81.16,69.29h-8.44c-.08,0-.16-.07-.19-.18l-3.51-17.39c-.05-.17.05-.36.19-.36h8.44c.08,0,.16.07.19.18l3.51,17.39c.05.17-.05.36-.19.36Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 24.9,
    y: 28.85,
    width: 19.78,
    height: 6.51,
    rx: 0.5,
    ry: 0.5,
    transform: "translate(69.58 64.21) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 46.72,
    y: 30.61,
    width: 21.87,
    height: 4.67,
    rx: 0.38,
    ry: 0.38,
    transform: "translate(115.31 65.89) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 45.92,
    y: 27.5,
    width: 18.97,
    height: 2.7,
    rx: 0.32,
    ry: 0.32,
    transform: "translate(110.81 57.7) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 27.57,
    y: 24.12,
    width: 18.97,
    height: 3.99,
    rx: 0.39,
    ry: 0.39,
    transform: "translate(74.11 52.23) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M55.95,141.56h-5.84c-.11,0-.21-.07-.25-.18l-6.21-17.31c-.06-.17.07-.35.25-.35h5.84c.11,0,.21.07.25.18l6.21,17.31c.06.17-.07.35-.25.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M46.01,141.56h-6.93c-.07,0-.13-.07-.16-.18l-3.87-18.11c-.04-.18.04-.37.16-.37h6.93c.07,0,.13.07.16.18l3.87,18.11c.04.18-.04.37-.16.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 59.27,
    y: 131.99,
    width: 20.92,
    height: 9.57,
    rx: 0.63,
    ry: 0.63,
    transform: "translate(139.45 273.55) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M58.22,127.39h19.27c.22,0,.4.18.4.4v3.18c0,.22-.18.4-.4.4h-19.27c-.22,0-.4-.18-.4-.4v-3.18c0-.22.18-.4.4-.4Z",
    transform: "translate(135.7 258.74) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M90.37,144.2H18.66V0h71.71v144.2ZM21.66,141.2h65.71V3H21.66v138.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 20.6,
    y: 69.31,
    width: 68.27,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 20.6,
    y: 103.21,
    width: 68.27,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 20.6,
    y: 35.41,
    width: 68.27,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M17.66,115.87c1.04-1.89.38-4.31-.87-6.07-1.34-1.88-3.34-3.3-5.59-3.85-2.24-.55-4.71-.22-6.68.97-.58.35-1.13.79-1.52,1.35-1.15,1.66-.59,4.07.79,5.55,1.38,1.48,3.37,2.2,5.32,2.74,1.82.5,7.51,2.63,8.26-.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M7.49,110.71c1.52-.03,2.96.48,4.34,1.06,1.3.55,2.59,1.21,3.67,2.13,2.06,1.75,3.3,4.26,4.1,6.79.25.81.46,1.63.67,2.45s.38,1.69.72,2.49c.09.21.43.21.42-.06-.01-.8-.17-1.58-.34-2.35s-.35-1.53-.58-2.29c-.42-1.4-.95-2.78-1.67-4.05-.67-1.19-1.51-2.29-2.54-3.2-1.12-.99-2.44-1.69-3.81-2.27-1.57-.66-3.27-1.19-4.99-1.06-.22.02-.23.36,0,.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M30.69,112.43c.4.84.87,1.75,1.72,2.14.51.23,1.08.24,1.63.33,1.58.27,2.94,1.23,4.33,2.01,1.4.79,3.03,1.43,4.57,1,1.74-.49,2.9-2.36,2.81-4.16-.09-1.81-1.27-3.45-2.84-4.37-2.25-1.31-5.03-1.19-7.49-.62-1.94.45-4.58,1.3-4.74,3.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M42.26,114.24c-1.09-1.13-2.52-1.89-4.01-2.33-1.62-.48-3.33-.64-5.01-.48s-3.22.6-4.63,1.46c-1.55.95-2.85,2.27-3.82,3.8-.49.77-.89,1.59-1.21,2.45s-.56,1.74-.64,2.65c-.02.23.03.45.07.67.03.15.28.19.34.04.09-.2.19-.4.23-.61s.1-.42.15-.63c.1-.43.2-.85.33-1.27.26-.82.6-1.6,1.02-2.35.83-1.47,1.97-2.79,3.36-3.76.36-.25.73-.47,1.11-.68.17-.09.35-.18.53-.26.16-.07.26-.11.45-.18.72-.27,1.46-.45,2.22-.56,1.52-.22,3.19-.15,4.72.15.78.16,1.53.39,2.27.68.68.27,1.34.62,1.92,1.07.14.11.28.23.41.35.14.13.34-.07.21-.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M20.34,108.72c1.77-2.79,2.43-6.27,1.8-9.52-.17-.91-.45-1.8-.93-2.59-1.45-2.37-2.96-4.81-4.55-7.09-1.38-1.98-3.35-3.72-5.72-4.39-1.92-.54-4-.35-5.88.31-2.05.71-4.12,2.14-4.75,4.32-.57,1.98-.3,4.17.38,6.09.73,2.05,2.27,3.04,3.69,4.58,1.15,1.25,1.99,2.72,3.19,3.92,1.18,1.18,2.54,2.19,4.04,2.93,2.33,1.15,5.02,2.28,8.73,1.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M22.89,91.93c-.87.25-1.82-.02-2.57-.52-.75-.5-1.34-1.2-1.92-1.89-2.2-2.64-4.44-5.34-5.75-8.52-.55-1.34-.93-2.75-1.17-4.18-.28-1.69-.36-3.44.07-5.1,1.25-4.93,6.5-5.89,10.81-4.58,4.73,1.44,6.18,6.51,6.97,10.84.68,3.69.85,7.74-1.08,10.95-.96,1.6-2.58,2.97-4.45,3.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M27.5,107.66c-1.99-1.2-2.98-3.65-2.94-5.97s.98-4.54,2.12-6.56c1.04-1.84,2.26-3.57,3.64-5.17,1.96-2.26,4.1-3.49,7.04-4.06,2.02-.39,4.24-.35,5.96.78.85.56,1.53,1.36,2.04,2.24,1.43,2.47,1.56,5.64.33,8.22-1.19,2.49-3.46,4.26-5.64,5.93-1.12.86-2.25,1.72-3.37,2.58-1.32,1.01-2.67,2.04-4.24,2.58-1.57.54-3.43.52-4.77-.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M41.7,90.86c-.38,0-.76.01-1.14.05-.35.04-.7.14-1.04.23-.57.16-1.13.36-1.65.63s-.97.63-1.42.99c-.53.43-1.04.89-1.51,1.38-.95.99-1.79,2.1-2.47,3.3-.35.62-.63,1.27-.96,1.89-.35.66-.73,1.31-1.13,1.95-.79,1.27-1.65,2.51-2.49,3.75-.62.92-1.23,1.84-1.75,2.83-.93,1.77-1.58,3.67-2.03,5.61-.26,1.14-.47,2.29-.62,3.45-.08.65-.15,1.3-.21,1.96-.06.71-.07,1.42-.1,2.14-.02.37-.03.73-.03,1.1,0,.14.24.19.26.04.1-.72.15-1.46.29-2.18.06-.34.09-.68.13-1.02s.09-.68.14-1.02c.16-1.16.33-2.33.57-3.48.4-1.95.97-3.87,1.82-5.64,1.06-2.2,2.57-4.14,3.89-6.18.8-1.24,1.57-2.5,2.2-3.83.57-1.21,1.27-2.35,2.12-3.38s1.84-1.97,2.94-2.75c.4-.28.81-.51,1.27-.69.29-.12.58-.22.88-.32.33-.1.68-.17,1.01-.27s.7-.18,1.05-.24c.18-.03.13-.32-.04-.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M18.11,73.16c1.21.9,2.04,2.15,2.64,3.52s.94,2.93,1.18,4.44c.27,1.69.41,3.4.56,5.1.17,1.92.32,3.84.45,5.76s.23,3.89.31,5.83.13,3.89.15,5.84.02,3.88-.01,5.82-.1,3.79-.21,5.69-.24,3.68-.42,5.52-.42,3.52-.62,5.29c-.02.21-.05.42-.07.64-.01.1-.02.2-.02.3s.02.23,0,.33c-.04.25.34.35.38.1.04-.21.15-.42.19-.63s.08-.42.12-.63c.08-.43.15-.87.22-1.3.14-.9.25-1.8.35-2.71.2-1.84.36-3.68.48-5.52s.21-3.82.26-5.73.07-3.89.06-5.83-.06-3.93-.14-5.89-.19-3.93-.32-5.9-.29-3.89-.47-5.83c-.17-1.81-.33-3.62-.58-5.41-.21-1.55-.52-3.09-1.07-4.56s-1.31-2.72-2.44-3.73c-.27-.24-.56-.47-.87-.67-.11-.08-.21.1-.11.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M6.97,91.9c2.46,1.25,4.51,3.19,6.1,5.42.87,1.22,1.6,2.54,2.34,3.85.78,1.4,1.55,2.8,2.3,4.21,1.29,2.42,2.6,4.83,3.52,7.42.38,1.05.69,2.13.94,3.22.12.53.23,1.06.32,1.59s.17,1.06.23,1.59c.14,1.19.24,2.39.31,3.59.08,1.39.17,2.78.24,4.17.02.38.07.75.12,1.12.03.24.36.25.38,0,.02-.39.05-.78.05-1.18s0-.75-.01-1.12c0-.7-.01-1.4-.04-2.1-.06-1.23-.13-2.47-.25-3.7-.23-2.25-.65-4.48-1.36-6.62-.84-2.57-2.07-4.96-3.34-7.34-.76-1.43-1.53-2.86-2.32-4.28s-1.55-2.75-2.43-4.06c-.78-1.16-1.67-2.26-2.69-3.23s-2.13-1.81-3.37-2.41c-.3-.15-.61-.28-.92-.41-.15-.06-.25.19-.11.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M18.56,106.04c-.46-.35-.92-.68-1.42-.98-.54-.33-1.1-.63-1.67-.91-1.16-.58-2.36-1.09-3.59-1.49-.61-.2-1.24-.37-1.89-.45-.12-.01-.13.16-.03.2.54.18,1.07.37,1.61.56.59.21,1.17.45,1.75.69,1.17.49,2.31,1.05,3.42,1.65.29.16.58.33.87.48.28.14.55.3.82.46.13.08.23-.11.12-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M15.25,100.15c0-.21,0-.42.01-.64s0-.42-.02-.64c-.03-.42-.07-.85-.12-1.27-.1-.86-.21-1.71-.33-2.57-.03-.23-.07-.47-.14-.69-.03-.11-.06-.23-.08-.34-.03-.12-.07-.24-.11-.36-.04-.13-.24-.11-.24.03,0,.42.03.84.08,1.26s.13.86.19,1.3c.12.84.22,1.69.34,2.53.03.23.05.46.1.69s.12.47.15.71c.01.1.17.07.17-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M12.1,95.77c-.14-.22-.33-.35-.57-.46-.26-.11-.52-.22-.79-.3-.56-.19-1.13-.36-1.7-.51-1.14-.3-2.3-.5-3.47-.64-.33-.04-.66-.05-.99-.07s-.66-.03-.99,0c-.14.01-.2.24-.04.27.56.1,1.12.14,1.68.23s1.13.15,1.69.25c1.12.2,2.24.45,3.33.77.31.09.61.18.92.27.25.07.53.16.73.33.1.08.27-.02.19-.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M21.87,79.29c-.07-.07-.14-.15-.21-.22s-.13-.15-.2-.21c-.15-.13-.29-.27-.44-.4-.3-.27-.61-.53-.92-.79s-.59-.51-.89-.76c-.27-.23-.55-.45-.86-.62-.17-.09-.36-.19-.54-.24-.1-.03-.21-.04-.31-.05s-.21.02-.31.04c-.06.01-.11.08-.11.14,0,.07.05.12.11.14.02,0,.03.01.05.02,0,0,.02,0,.03,0,0,0,.04.02.02,0-.02,0,0,0,.01,0,0,0,.02,0,.02.01.03.01.06.03.09.04.08.02.15.05.23.08,0,0,.03.01,0,0-.04-.02.05.02.03.01.02.01.05.02.07.03.02,0,.03.01.05.02.03.01-.01,0-.01,0,.01,0,.02.01.03.01.08.03.15.07.23.11.14.08.28.17.41.27.07.05.13.1.2.15,0,0,.02.01.02.02,0,0-.03-.03-.01,0,.02.01.03.02.05.04.04.03.07.06.11.08.3.24.59.48.88.73.31.26.62.52.94.77.17.13.34.27.52.4s.37.25.56.37c.12.07.23-.09.14-.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M22.83,83.96c.85-1.99,1.57-4.08,1.76-6.25.05-.6.09-1.24-.09-1.82-.04-.12-.24-.14-.26,0-.09.53-.08,1.06-.12,1.6s-.11,1.04-.2,1.56c-.18,1.05-.49,2.07-.77,3.09-.16.59-.33,1.17-.48,1.76-.02.09.12.17.16.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M23.12,89.01c-.02-.21-.05-.42-.1-.63s-.13-.4-.22-.6c-.17-.38-.39-.73-.64-1.06-.27-.36-.56-.7-.84-1.04-.32-.38-.64-.75-.96-1.12-.18-.21-.37-.4-.56-.6-.09-.1-.19-.2-.28-.3-.1-.1-.21-.19-.32-.29-.11-.09-.27.02-.2.15.06.1.11.21.18.3s.15.2.22.3c.15.19.29.39.44.58.3.39.62.77.94,1.15.28.33.57.67.85,1.01.03.04.06.08.09.12.03.04-.01-.01.02.02.02.02.03.04.05.07.06.08.12.17.19.26.12.17.24.33.35.51.12.19.21.4.31.6s.18.4.23.62c.03.14.27.11.25-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M28.27,105.04c.59-.22,1.16-.48,1.75-.71s1.19-.44,1.79-.63c1.2-.38,2.42-.71,3.65-.98.34-.07.69-.14,1.03-.21s.71-.13,1.04-.25c.19-.07.17-.36-.05-.37-.33,0-.65.06-.98.11s-.62.12-.93.18c-.63.13-1.25.28-1.87.44-1.23.32-2.43.71-3.61,1.18-.67.26-1.35.53-1.97.9-.18.1-.06.42.14.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M31.75,99.58c-.09-.49.04-1.01.15-1.49s.23-.99.35-1.48c.25-.99.55-1.97.88-2.93.05-.14.09-.27.14-.41s.1-.27.13-.41.06-.26.1-.4c.04-.14.09-.28.13-.43.03-.12-.13-.18-.19-.08-.27.46-.52.92-.72,1.42s-.37.97-.52,1.47c-.31,1-.57,2.01-.75,3.04-.05.29-.11.59-.12.88s.03.61.12.89c.06.19.33.11.29-.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M34.13,95.53c.8-.29,1.61-.52,2.44-.67s1.63-.26,2.47-.33c.24-.02.48-.04.72-.07.12-.01.25-.02.37-.04.06,0,.11-.01.17-.03.06-.02.12-.05.18-.07s.11-.07.11-.14c0-.06-.04-.12-.11-.14-.11-.03-.21-.05-.32-.06s-.23,0-.34,0c-.21,0-.42.02-.63.04-.43.04-.86.08-1.29.13s-.88.12-1.31.21c-.41.09-.81.2-1.21.33-.46.15-.92.35-1.34.59-.12.07-.04.28.1.23h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "32.16 148.04 12.35 148.04 8.53 119.34 35.98 119.34 32.16 148.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "35.02 126.53 35.12 125.77 9.39 125.77 9.49 126.53 35.02 126.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M33.65,111.89s.09.08.14.11c.05.04.11.07.17.1.11.07.21.13.32.2.21.14.43.27.64.41.1.07.21.14.31.22.05.04.1.08.15.12.02.01,0,0,0,0,0,0,.01,0,.02.01.01,0,.02.02.04.03.03.03.07.05.1.08.03.02.05.04.08.06.01,0,.02.02.03.02,0,0,.03.02,0,0,0,0,.01.01.02.02.05.04.1.08.15.12.1.08.19.16.29.24.11.09.21.19.32.28.04.04.08.07.13.09-.03-.01,0,0,0,0,.02,0,.03.01.05.02,0,0-.02,0,0,0,0,0,.01.01.02.02.06.04.12.08.17.12.08.06.19-.06.13-.13s-.12-.16-.18-.24l.04.06s-.03-.07-.05-.1c-.02-.03-.05-.06-.08-.09-.04-.04-.08-.09-.13-.13-.09-.08-.18-.16-.27-.23-.19-.16-.38-.31-.58-.46s-.39-.26-.6-.38-.41-.24-.62-.34c-.13-.06-.25-.11-.38-.16-.06-.02-.12-.05-.18-.07s-.13-.03-.2-.04c-.02,0-.05.03-.03.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M37.7,112.3c.28-.02.56-.02.84-.04s.57-.04.85-.05c.57-.02,1.13,0,1.7.04.15.01.31.02.46.03.08,0,.15,0,.23,0,.08,0,.17,0,.25-.01.06-.02.08-.11.02-.14-.06-.03-.13-.05-.2-.06s-.14-.04-.21-.05c-.15-.03-.3-.04-.45-.05-.28-.03-.56-.03-.84-.04-.57,0-1.14.02-1.71.07-.17.02-.33.04-.49.07s-.31.07-.47.1c-.08.02-.06.14.02.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M8.94,113.36c1.25-.32,2.5-.64,3.79-.72.18-.01.36-.02.54-.02.09,0,.17,0,.26,0,.09,0,.19.02.28,0,.07,0,.13-.05.14-.12,0-.07-.03-.14-.1-.15-.08-.02-.17-.02-.25-.02-.09,0-.17,0-.26,0-.16,0-.32,0-.48.01-.33.02-.66.06-.99.11-.64.11-1.27.27-1.89.46-.36.1-.71.22-1.07.34-.07.02-.04.13.03.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M13.46,109.75c.21.18.4.38.57.6.08.11.16.23.24.34s.16.23.24.36c.15.25.28.51.4.78,0,.02.02.05.03.08.02.04.03.08.05.11.03.07.06.15.08.22.05.15.1.3.14.45s.09.3.12.45c.02.08.03.16.05.24,0,.04.01.08.02.11.02.08.09.15.17.17.13.04.22-.06.25-.17.03-.1-.03-.22-.06-.31-.05-.15-.1-.3-.15-.45-.19-.59-.44-1.17-.77-1.71-.15-.24-.32-.48-.52-.69s-.41-.38-.64-.54c-.06-.04-.12-.08-.18-.12-.04-.02-.08.03-.05.06h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M67.13,170.53s-7.55-6-9.43-4.21c-1.79,1.71.65,3.56,6.66,6.52,6,2.95,6.1-.39,2.78-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M72.23,153.3l-6.79,12.77s5.37,5.37,4.8,6.35-10.72-3.26-11.11-5.48c-.08-.47,1.44-2.78,1.81-3.61l5.69-14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M62.97,172.15s2.3-3.88,4.13-5.56c3,2.21,4.1,5.61,3.28,7.03-1.06,1.83-5.11-.14-7.41-1.47Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M106.45,172.21s-9.19-2.84-10.28-.89c-1.04,1.85,1.91,2.7,8.55,3.49,6.64.79,5.5-1.94,1.73-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M105.27,154.35l-2.01,14.33s6.89,3.2,6.69,4.32c-.2,1.12-11.19.61-12.31-1.34-.24-.42.41-3.1.47-4.02l.55-15.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M103.19,174.62s.71-3.74,1.79-5.58c3.59.98,5.85,3.43,5.61,4.8-.31,1.76-4.79,1.24-7.4.78Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M72.96,84.31s-1.65,7.23-1.65,15.77.83,22.17.83,24.64-9.85,32.19-9.85,32.19l14.12,6.73s11.72-19.93,14.45-39.42c1.66-11.83,2-25.79,1.51-34.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M83.48,87.81s.76,7.37,3.5,15.46c2.74,8.09,7.9,20.73,8.7,23.07.79,2.33-.57,33.91-.57,33.91l15.54,1.84s4.48-22.64,2.61-42.23c-1.41-14.84-3.61-25.19-6.73-34.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.77,116.21s1.86-14.69,1.44-21.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M72.23,161.64s10.09-26.75,11.73-35.78c1.6-8.8,2.15-38.43,2.15-38.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M103.77,89.38s6.58,22.23,5.8,35.99c-.51,9.02-2.69,36.28-2.69,36.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M73.45,90.06s5.09,2.46,8.54-.99"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M122.12,54.16s2.61,14.69,3.26,16.45c2.11,5.68,8.65,26.85,8.65,26.85l-2.73.71s-13.33-16.83-17.66-26.04c-2.99-6.36-5.66-18.67-5.66-18.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M88.17,40c-14.15,14.15-15.87,38.27-16.85,45.92,11.17,8.42,37.83,4.69,37.83,4.69,0,0,.14-7.07,1.2-16.11.91-7.76,6.68-22.93,6.68-22.93l-1.83-12.82-19.26-3.27-7.76,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M115.19,38.75s5.38,4.25,7.29,11.32c1.92,7.07,3.16,15.14,3.16,15.14l-16.5,2.93-5.24-14.94"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M75.85,44.12s-9.15,7.61-10.16,14.23c-1.58,10.35,19.34,25.61,19.34,25.61l1.94-1.56s-9.69-20.79-9.54-21.41c.42-1.63,15.78-14.35,15.78-14.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M100.92,34.2s-9.42-1.46-15.3,1.28c-5.88,2.75-14.3,12.34-14.3,12.34l11.09,11.82,12.41-8.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "92.58 52.27 82.4 59.66 71.31 47.83"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M111.6,67.35s2.31-10.91,5.42-14.39"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M20.59,179.35s-7.45-2.56-8.09-5.52c-.65-2.97,2.2-8.46,3.6-9.86,3.58-3.58,14.09-5.44,19.35-5.44,3.5,0,10.8,4.29,10.8,4.29l-2.18,10.51-23.48,6.03Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 134.03,
    y1: 102.29,
    x2: 160.81,
    y2: 170.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.62,177.01c22.67-2.83,9.85-70.79,37.82-87.02,17.7-10.27,45.93-5.79,56.42,12.55"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M149.77,172.62l19.73-4.19c.33-.09.69-.05,1,.1l3.82,1.82-19.08,4.82-5.47-2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M149.22,173.16l-.1.45c-.1.43.19,1.57.6,1.71l5.55,1.9-.04-2.05-5-2.49c-.41-.21-.91.03-1.01.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "155.24 175.17 174.32 170.34 174.36 171.9 155.28 177.21 155.24 175.17"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M45.89,162.65c-1.62-.48-16.08,2.45-21.11,6.15-3.64,2.67-6.57,9.57-4.19,10.55,3.34,1.37,25.79.16,27.13-1.18,3.2-3.2,1.51-14.52-1.83-15.51Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M44.63,174.08c-.15,2.95-.69,5.72-3.05,6.67-.76.3-2.78.12-3.63.08-3.5-.17-6.18-3.47-5.99-7.37s3.18-6.92,6.68-6.75c1.25.06,3.61.1,4.55.85,1.7,1.34,1.56,4.02,1.43,6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M47.04,174.2c-.19,3.9-3.18,6.92-6.68,6.75-3.5-.17-6.18-3.47-5.99-7.37.19-3.9,3.18-6.92,6.68-6.75,3.5.17,6.18,3.47,5.99,7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M43.11,174c-.07,1.48-1.21,2.63-2.54,2.57-1.33-.07-2.35-1.32-2.28-2.8.07-1.48,1.21-2.63,2.54-2.57s2.35,1.32,2.28,2.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M20.65,163.06c1.3.6,3.94,2.31,4.3,2.37,1.87-.35,8.16-2.44,12.53-3.26-1.52-.85-4.94-2.33-5.26-2.4-.3-.06-8.67,1.52-11.58,3.29"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M17.13,165.74c.11.08.22.16.34.24.15.1.31.19.46.28.38.22.76.42,1.14.63.75.41,1.53.79,2.29,1.17.14.07.28.14.42.21.05.02.1.05.15.07s.1.06.17.06c0,0,.02,0,.03,0,0,0,0,0,0,0,0,0,0,0,0,0,.07,0,.07,0,0,0,.08,0,.15-.05.18-.12.03-.08.01-.15-.04-.21h0s.03.06.05.08c-.03-.08-.08-.15-.16-.19-.04-.02-.08-.04-.13-.06-.12-.06-.24-.12-.36-.18-.34-.17-.69-.35-1.03-.52-.8-.41-1.61-.82-2.41-1.24-.18-.1-.36-.2-.55-.29-.14-.07-.29-.14-.43-.21-.07-.04-.17-.02-.21.05-.05.08-.01.16.05.21h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M15.96,167.62c.11.08.22.16.34.24.15.1.31.19.46.28.38.22.76.42,1.14.63.75.41,1.53.79,2.29,1.17.14.07.28.14.42.21.05.02.1.05.15.07s.1.06.17.06c0,0,.02,0,.03,0,0,0,0,0,0,0,0,0,0,0,0,0,.07,0,.07,0,0,0,.08,0,.15-.05.18-.12.03-.08.01-.15-.04-.21h0s.03.06.05.08c-.03-.08-.08-.15-.16-.19-.04-.02-.08-.04-.13-.06-.12-.06-.24-.12-.36-.18-.34-.17-.69-.35-1.03-.52-.8-.41-1.61-.82-2.41-1.24-.18-.1-.36-.2-.55-.29-.14-.07-.29-.14-.43-.21-.07-.04-.17-.02-.21.05-.05.08-.01.16.05.21h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M14.93,168.53c.11.08.22.16.34.24.15.1.31.19.46.28.38.22.76.42,1.14.63.75.41,1.53.79,2.29,1.17.14.07.28.14.42.21.05.02.1.05.15.07s.1.06.17.06c0,0,.02,0,.03,0,0,0,0,0,0,0,0,0,0,0,0,0,.07,0,.07,0,0,0,.08,0,.15-.05.18-.12.03-.08.01-.15-.04-.21h0s.03.06.05.08c-.03-.08-.08-.15-.16-.19-.04-.02-.08-.04-.13-.06-.12-.06-.24-.12-.36-.18-.34-.17-.69-.35-1.03-.52-.8-.41-1.61-.82-2.41-1.24-.18-.1-.36-.2-.55-.29-.14-.07-.29-.14-.43-.21-.07-.04-.17-.02-.21.05-.05.08-.01.16.05.21h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M133.14,103.37c-.11.16-.64.11-.68-.22-.25.05-.52.06-.75-.05-.23-.11-.41-.35-.39-.6-.42.08-.85-.18-1.07-.55-.22-.37-.27-.81-.26-1.24,0-.54.01-2.47,1.05-1.74,1.07.75,1.58,1.84,1.42,3.18,0,0,.45.71.53.86.11.2.14.37.14.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M131.78,96.92c-.74,1.76.76,2.97,1.66,4.26.1.15.2.31.24.49.04.15.03.3.03.46,0,.38,0,.76-.01,1.14,0,.18,0,.36.07.52.07.16.23.3.4.28.22-.02.36-.25.45-.45.29-.6.58-1.22.69-1.89.28-1.75-.3-4.18-1.99-5.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M84.02,82.74c.11,1.07.3,2.27,1.17,2.89.35.25.78.38,1.07.69.2.22.32.51.54.7.22.19.63.23.77-.03.22.38.89.33,1.05-.07.05.18.26.31.45.29.19-.03.35-.21.35-.4.02.25.37.35.58.22.21-.13.3-.39.36-.63.12-.52.14-1.07.08-1.6-.02-.15-.05-.31-.13-.44-.09-.13-.22-.23-.35-.32-1.63-1.08-3.43-1.91-5.31-2.47"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M113.36,30.43l-2.33,5.39s2.94,1.71,4.16,2.93c-.28.9-3.79,4.9-7.71,3.92-8.22-2.07-9.62-8.77-9.62-8.77l5.51.25,4.4-8.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M121,22.48c.11,2.94-1.16,7.32-3.2,9.62-2.3,2.57-6.66,1.3-8.11-1.56-1.13-2.24-1.88-4.99-1.17-6.93,1.39-3.77,12.32-5.33,12.48-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M112.24,33.14c-1.42-.53-2.06-1.38-2.67-2.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.84,26.5c-1.39.23-2.52-1.22-2.58-2.48-.02-.41.01-1.06.14-1.46.17-.53.71-.82.93-1.32.24-.54.05-1.17-.14-1.73-.19-.6-.37-1.21-.38-1.83-.01-.63.15-1.28.57-1.74.63-.7,1.67-.84,2.62-.82.94.02,1.92.15,2.8-.19.56-.22,1.04-.61,1.58-.87,2-.97,4.8.18,5.97,1.96.32.49.6,1.07,1.14,1.27.59.2,1.21-.14,1.82-.23.77-.11,1.54.18,2.18.61.39.26.76.58.95,1.01.15.34.18.72.17,1.09-.1,2.14-1.97,4.04-4.11,4.18-1.57.1-3.08-.66-4.29-1.66-.27-.23-.55-.47-.88-.59-.79-.27-1.69.23-2.48-.03-.51-.17-.94-.65-1.47-.56-.44.07-.71.51-.82.94-.11.43-.1.88-.26,1.29-.37.93-1.27.98-1.87,1.61-.55.58-.66,1.37-1.61,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M110.34,26c-.02-.37-.15-.74-.38-1.03-.08-.11-.18-.21-.31-.26-1.56-.67-1.97,2.09-1.57,3.03.28.65,1.26,1.36,1.92.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M113.25,23.87c.57-.26,1.19-.32,1.76-.15.23.07.45.17.67.27.28.13.62.29.22.64-.12.1-.12.19-.32.07-.71-.43-1.55-.47-2.34-.65-.04,0-.09-.03-.09-.08,0-.05.05-.09.09-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M120.13,26.13c-.11-.43-.35-.75-.69-.9-.14-.06-.29-.1-.44-.13-.23-.05-.42-.03-.5.31,0,.03-.01.06,0,.08,0,.02.03.03.05.03.56.16,1.05.32,1.49.73.02.02.05.02.08,0,.03-.03.03-.08.02-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M113.59,25.37c.06-.05.12-.08.19-.07.12,0,.33.05.36.2.08.36-.21.93-.6.81-.35-.1-.22-.73.05-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M118.46,27.64c.06-.05.12-.08.19-.07.12,0,.33.05.36.2.08.36-.21.93-.6.81-.35-.1-.22-.73.05-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M117.02,26.73s-.12,2.85-.69,3c-.57.15-1.5-.46-1.5-.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M114.91,31.59s-2.37-.48-2.33-2.07"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCare3);
export default __webpack_public_path__ + "static/media/care3.65ae152d7f0229360d90fd5cd71bb3c9.svg";
export { ForwardRef as ReactComponent };